import cn from "classnames";
import React from "react";

import { makeBEM } from "utils";

import { Button, ButtonProps } from "../Button";

import "./index.scss";

export interface MeButtonProps extends ButtonProps {
  variant?: "primary" | "secondary";
  reverseEdges?: boolean;
}

const bem = makeBEM("me-button");

const primaryProps: ButtonProps = {
  color: "primary",
};
const secondaryProps: ButtonProps = {
  color: "secondary",
  bordered: true,
};

export const MeButton: React.FC<MeButtonProps> = React.forwardRef<HTMLButtonElement, MeButtonProps>(
  ({ className, variant = "primary", reverseEdges = variant === "secondary", size = "lg", ...props }, ref) => {
    return (
      <Button
        className={cn(
          bem(null, {
            "reverse-edges": reverseEdges,
          }),
          className,
        )}
        {...(variant === "primary" ? primaryProps : secondaryProps)}
        size={size}
        {...props}
        ref={ref}
      />
    );
  },
);
